import React from "react";
import PropTypes from "prop-types";
import SearchCompanyName from "./SearchCompanyName";

export default class SearchCompanyField extends React.Component {
  constructor(props) {
    super();

    this.state = {
      selected: props.selectedCompany
    };
  }

  onChange = () => {
    this.props.company_id.input.onChange(null);
    this.props.contact_id.input.onChange(null);
  };

  onSelect = (result, value) => {
    const { company_id, contact_id, onResultSelected } = this.props;

    const id = result ? result.id : null;
    company_id.input.onChange(id);
    company_id.input.onBlur(id);

    const val = result ? null : value;
    contact_id.input.onChange(val);
    contact_id.input.onBlur(val);

    this.setState({ selected: result });

    if (result) onResultSelected(result);
  };

  render() {
    return (
      <SearchCompanyName
        company={this.state.selected}
        onSelect={this.onSelect}
        {...this.props}
      />
    );
  }
}

SearchCompanyField.propTypes = {
  company_id: PropTypes.instanceOf(Object).isRequired,
  contact_id: PropTypes.instanceOf(Object).isRequired,
  onResultSelected: PropTypes.func.isRequired,
  selectedCompany: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/FindOrCreateCompanyToggle/SearchCompanyField.jsx